const Rate = ({ value }) => {
  return (
    <span className="text-grayBlack text-[13px] font-medium">
      {value ? `$${value}` : "N/A"}
    </span>
  );
};

export default Rate;
